import { get, isNaN } from 'lodash';
import { IProduct, Laboratory, ProductGroup, ShopCouponTypesEnum } from '../../modules/types';
import { getTranslationKey } from '../../modules/utils';
import { displayAmount } from '../../modules/utils/helpers/display-price';

export const fieldsMargin = '10px 10px 10px 0';

export const typeOptions = () => {
  const options = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const [propertyKey, propertyValue] of Object.entries(ShopCouponTypesEnum)) {
    if (!Number.isNaN(Number(propertyKey))) continue; // eslint-disable-line no-continue

    const isDisabled = ['Shipping'].includes(propertyKey);

    if (!isDisabled) {
      options.push({
        value: propertyValue,
        text: getTranslationKey(`shop.coupons.${propertyValue}`),
        isDisabled
      });
    }
  }

  return options;
};

export const productGroupsOption = (list: ProductGroup[]) =>
  list.map((item) => {
    const title = get(item, 'title', { en: '', de: '' });
    const couponTitle = get(item, 'couponTitle', title);

    return {
      value: item.id,
      text: window.LANGUAGE_SW === 1 ? couponTitle.en : couponTitle.de
    };
  });

export const productsOption = (list: IProduct[], laboratories: Laboratory[]) =>
  list.map((item) => {
    const titleTranslations = get(item, 'title', { en: '', de: '' });
    const title = window.LANGUAGE_SW === 1 ? titleTranslations.en : titleTranslations.de;
    const laboratory = laboratories.find((lab) => lab.id === item.laboratory);
    const labName = laboratory?.name || getTranslationKey('digitalFiles');
    const dimensions = item.dimensions ? ` ${item.dimensions.width}x${item.dimensions.height}` : '';

    return {
      value: item.id,
      text: `${labName} | ${title}${dimensions}`
    };
  });

export const validateMaxQ = (value: unknown) => {
  const num = parseInt(value as string, 10);
  if (isNaN(num)) return '';
  if (num <= 0) return 1;

  return num;
};

export const validatePercent = (value: unknown) => {
  const num = parseInt(value as string, 10);
  if (isNaN(num)) return '';
  if (num <= 0) return 1;
  if (num > 100) return 100;

  return num;
};

export const showValue = (value?: number) =>
  value ? String(displayAmount(Number(value)).toFormat('0.00')) : '';
